import * as Cookies from 'js-cookie'

import { COOKIE_AUTH_DATA } from './constant'

function getUserCookie(name = COOKIE_AUTH_DATA) {
  return Cookies.getJSON(name)
}

export default getUserCookie
